export function assertPaginationControlled(
  pagination: unknown,
  tagName: "<Table>" | "<List>",
  hasWrapperLevelOnChange = false
): void {
  if (process.env.NODE_ENV === "production") return;

  if (typeof pagination !== "object" || pagination === null) return;

  const p = pagination as { pageSize?: unknown; onChange?: unknown };
  const hasPageSize = "pageSize" in p && p.pageSize !== undefined;
  const hasPaginationOnChange = typeof p.onChange === "function";

  if (!hasPageSize || hasPaginationOnChange || hasWrapperLevelOnChange) return;

  const onChangeHint =
    tagName === "<Table>"
      ? "pagination.onChange (or the Table-level onChange)"
      : "pagination.onChange";

  throw new Error(
    `${tagName} pagination.pageSize is set without an onChange handler. antd treats pageSize as ` +
      "controlled, so the user's size-changer selection is clobbered on every re-render. Use " +
      `defaultPageSize for an uncontrolled initial size, or pass ${onChangeHint} to control it. See HR-1668.`
  );
}
